let bundle_builder_section = document.querySelector('.bundle-builder');
let bundle_builder_products = bundle_builder_section.querySelectorAll('.product-grid-item');
let bundle_builder_progress_block = bundle_builder_section.querySelector('.progress-block');
let bundle_builder_added_products = bundle_builder_section.querySelector('.added-products');
let bundle_builder_add_to_cart = bundle_builder_section.querySelector('.add-to-cart-button');
let bundle_builder_items_treshold = bundle_builder_add_to_cart.dataset.itemsTreshold;

let bundle_builder_manage_block = bundle_builder_section.querySelector('.builder-manage-block');
let bundle_builder_total_price_block = bundle_builder_manage_block.querySelector('.total');
let bundle_builder_result_price = bundle_builder_total_price_block.querySelector('.result-price');
let bundle_builder_actual_price = bundle_builder_total_price_block.querySelector('.actual-price .value');
let bundle_builder_savings_amount = bundle_builder_total_price_block.querySelector('.savings .value');
let bundle_builder_result_price_add_to_cart = bundle_builder_section.querySelector('.add-to-cart-button .value');


/*
    Initial page open - get actuall bundle widget state, it helps to restore bundle state in case a user refreshes the page
*/
if(creating_bundle.length == 0){
    creating_bundle = get_bundle_state();
}



/*
    Initial page open - select all previously selected items.
    We need it in case a user refreshes the page, or opens "Edit" mode. 
*/
bundle_builder_products.forEach(product => {
    if(creating_bundle.some(item => item.product_id == product.dataset.productId)){
        product.classList.add('choosed');
        add_product_to_added_products(product);
    }
});
actions_after_bundle_state_change();



bundle_builder_products.forEach(product => {
    let product_img = product.querySelector('.product__media');
    product_img.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let current_state = product.classList.contains('choosed');
        if(!current_state && creating_bundle.length >= creating_bundle_limitation){
            return;
        }
        if(current_state){
            remove_product_from_added_products(product.dataset.productId);
        }
        else{
            product.classList.add('choosed');

            let product_price = Number(JSON.parse(product.querySelector('.product-grid-item noscript').innerHTML).Price.replace(/[^\d.]/g, ''));

            creating_bundle.push({
                product_id:product.dataset.productId,
                product_price:product_price
            });
            add_product_to_added_products(product);
        }
        actions_after_bundle_state_change();
    });
});

bundle_builder_added_products.querySelectorAll('li').forEach(item => {
    item.querySelector('.icon-close').addEventListener('click', (e) => {
        remove_product_from_added_products(item.dataset.productId);
        actions_after_bundle_state_change();
    });
});



/*
    Add created bundle to the cart.
    We don't need any safety check (because it all runs in the Shopify Discount Extensions) so in case the button doesn't have "active" class - CSS rule will prevent click.
*/
bundle_builder_add_to_cart.addEventListener('click', (e) => {

    let bundle_id_timestamp = edit_bundle_id ? edit_bundle_id : String(Date.now());
    let items = creating_bundle.map(item => ({
        id: item.product_id,
        quantity: 1,
        properties: {
            _bundle: bundle_data.unique_name,
            _bundle_id: bundle_id_timestamp,
            _bundle_page: window.location.pathname.replace(/\/edit-\d+$/, '')
        }
    }));


    bundle_builder_added_products.querySelectorAll('.its-gift-reward.active').forEach(item=>{
        items.push({
            id: item.dataset.id,
            quantity: 1,
            properties: {
                _bundle: bundle_data.unique_name,
                _bundle_id: bundle_id_timestamp,
                _bundle_page: window.location.pathname.replace(/\/edit-\d+$/, ''),
                _bundle_gift: true
            }
        })
       
    })
    

    if(edit_bundle_id){
        fetch('/cart/update.js',{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                updates: edit_initial_bundle,
            })
        }).finally(() => {
            add_to_cart();
        });
    }
    else{
        add_to_cart(bundle_id_timestamp);
    }

    

    function add_to_cart(bundle_id_timestamp){
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items})
        }).then(response => response.json())
        .then((data) => {

            cart.getCart();


            bundle_builder_manage_block.classList.add('edit-view');

            edit_bundle_id = bundle_id_timestamp;

            edit_initial_bundle = {};
            data.items.forEach(item => {
                edit_initial_bundle[item.key] = 0;
            });

            //We are now in the "Edit" state - clear bundle state
            localStorage.setItem('creating_bundle', JSON.stringify([]));


        });
    }
});



function actions_after_bundle_state_change(){
    show_bundle_progress_state();
    
    //We don't need save bundle state if we are in the "Edit" state 
    if(!edit_bundle_id){
        save_bundle_state();
    }

    check_bundle_state();
    update_bundle_total_price();
}


function add_product_to_added_products(product){
    let adding_product_box = bundle_builder_added_products.querySelector('li:not(.added)');
    adding_product_box.dataset.productId = product.dataset.productId;
    adding_product_box.classList.add('added');
    adding_product_box.querySelector('.image').appendChild(product.querySelector('.product__media img').cloneNode(true));


    adding_product_box.querySelector('.title .product-name').textContent = product.dataset.productTitle;
    adding_product_box.querySelector('.title .variant-name').textContent = product.dataset.variantTitle;

    let gift_reward_check = adding_product_box.nextElementSibling;
    if(gift_reward_check && gift_reward_check.classList.contains('its-gift-reward')){
        gift_reward_check.classList.add('active');
    }
}






function remove_product_from_added_products(product_id){
    let deleting_product_box = bundle_builder_added_products.querySelector(`li[data-product-id="${product_id}"]`);
    deleting_product_box.classList.remove('added');
    deleting_product_box.querySelector('.image img').remove();

    deleting_product_box.querySelector('.title .product-name').textContent = '';
    deleting_product_box.querySelector('.title .variant-name').textContent = 'Select an Item';
    
    deleting_product_box.dataset.productId = '';    
    bundle_builder_added_products.appendChild(deleting_product_box);


    bundle_builder_section.querySelector('.product-list .product-grid-item[data-product-id="' + product_id + '"]').classList.remove('choosed');
    creating_bundle = creating_bundle.filter(item => item.product_id !== product_id);


    //Move all GIFT elements
    bundle_builder_added_products.querySelectorAll('.its-gift-reward').forEach((item,i)=>{
        if(item.dataset.position > creating_bundle.length){
            item.classList.remove('active');
        }
        if(item.dataset.position != i ){
            let nextItem = item.nextElementSibling;
            if (nextItem){
                bundle_builder_added_products.insertBefore(item, nextItem.nextElementSibling);
            }
        }
    })


}






function update_bundle_total_price(){

    //Just hide the Total Price Block in case there is no added products
    if(!creating_bundle.length){
        bundle_builder_total_price_block.classList.remove('active');
        bundle_builder_manage_block.classList.remove('bundle-reward-applied')
        return false;
    }
    else{
        bundle_builder_total_price_block.classList.add('active');
    }

    let total_price = creating_bundle.reduce((acc, item) => acc + item.product_price, 0);
    let result_price = total_price;

    //Calculate Saving Amount because of Gift Products
    let gift_products_price = 0;
    bundle_builder_added_products.querySelectorAll('.its-gift-reward.active').forEach(item=>{
        gift_products_price+=Number(item.dataset.price);
    })

    //Calculate the discount (percent) that will be applied based on amount of added products
    let max_discount = 0;
    for(let discount in bundle_data){
        if(creating_bundle.length >= discount){
            max_discount = bundle_data[discount];
        }
    }

    //Calculate the actual discount value
    if(max_discount > 0 || gift_products_price > 0){
        result_price = total_price * (1 - max_discount / 100); 
        bundle_builder_manage_block.classList.add('bundle-reward-applied')
        bundle_builder_actual_price.textContent = themeVendor.themeCurrency.formatMoney(total_price*100 + gift_products_price, theme.moneyFormat);
        bundle_builder_savings_amount.textContent =  themeVendor.themeCurrency.formatMoney(total_price*100 + gift_products_price - result_price*100, theme.moneyFormat);
        bundle_builder_result_price_add_to_cart.textContent = themeVendor.themeCurrency.formatMoney(result_price*100,theme.moneyFormat);
    }
    else{
        bundle_builder_manage_block.classList.remove('bundle-reward-applied')
    }

    //Show real price (after discount apply)
    bundle_builder_result_price.textContent = themeVendor.themeCurrency.formatMoney(result_price*100,theme.moneyFormat);
}


function show_bundle_progress_state(){
    bundle_builder_progress_block.querySelectorAll('.gift-step').forEach((step, index) => {
        step.classList.remove('active');
        if(index == creating_bundle.length - 1){
            step.classList.add('active');
        }
    });
}

/*
    This function add "active" class to the "Add To Cart" button, with the "active" class user can clicks on the button
*/
function check_bundle_state(){

    creating_bundle.length >= bundle_builder_items_treshold ? bundle_builder_manage_block.classList.add('add-to-cart-available') : bundle_builder_manage_block.classList.remove('add-to-cart-available');

    // creating_bundle.length >= bundle_builder_items_treshold ? bundle_builder_add_to_cart.classList.add('active') : bundle_builder_add_to_cart.classList.remove('active');
}


function save_bundle_state(){
    localStorage.setItem('creating_bundle', JSON.stringify(creating_bundle));
}

function get_bundle_state(){
    let bundle_state = localStorage.getItem('creating_bundle');
    if(bundle_state){
        return JSON.parse(bundle_state);
    }
    return [];
}




